/**
 * HeyNow chatbot is always visible across all sections of the site.
 */
export const HEYNOW_HIDDEN_BODY_CLASS = 'bqm-heynow-chat-hidden';

/** Always returns false — chatbot must persist on every route. */
export function shouldHideHeyNowForUrl(_url: string): boolean {
  return false;
}

export function applyHeyNowVisibilityForUrl(url: string): void {
  document.body.classList.toggle(HEYNOW_HIDDEN_BODY_CLASS, shouldHideHeyNowForUrl(url));
}
